<template>
  <el-card shadow="hover">
    <div class="head-tit" style="padding-bottom: 15px">退货费-查看详情</div>
    <!-- 列表 -->
    <tablelist
      :list="returnCostDetailList"
      :fieldList="fieldList"
      :btns="[]">
      <template v-slot:col-price="scope">
          <label v-if="scope.row.price">{{parseFloat(scope.row.price).toFixed(2)}}</label>
          <label v-else>-</label>
      </template>
      <template v-slot:col-money="scope">
          <label v-if="scope.row.money">{{parseFloat(scope.row.money).toFixed(2)}}</label>
          <label v-else>-</label>
      </template>
      <template v-slot:col-startPrice="scope">
          <label v-if="scope.row.startPrice">{{parseFloat(scope.row.startPrice).toFixed(2)}}</label>
          <label v-else>-</label>
      </template>
      <template v-slot:col-taskCode="scope">
        <el-link v-if="scope.row.taskCode" type="primary" :underline="false"
            @click="assignmentBtn(scope.row)">{{scope.row.taskCode}}</el-link>
        <label v-else>-</label>
      </template>
      <template v-slot:col-num="scope">
          {{ scope.row.num |tofixed }}
      </template>
    </tablelist>
    <!-- 底部合计 -->
    <div class="btm-context">
      <div style="float:left" v-if="$route.params.computeTypeName === '重量'">备注：不足起步价按起步价算，其余按续重算</div>
      <div style="float:right">费用合计：{{this.money}}元</div>
    </div>
  </el-card>
</template>

<script>
import costMenu from '../../store/costMenu/index.js'
import { GETRETURNDETAIL } from '../../store/costMenu/types.js'
import tablelist from './components/Table'
import { mixin } from './components/mixins'
import {toWarehouse} from '@/utils/toWarehouse'
export default {
  name: 'returncostdetail',
  data () {
    return {
      code: '', // 商品编码
      money: 0 // 总费用
    }
  },
  components: {
    tablelist
  },
  computed: {
    // 列表数据
    returnCostDetailList () {
      return costMenu.state.returnCostDetailList
    },
    fieldList () {
      if (this.$route.params.computeTypeName === '箱') {
        let arr = [
          { label: '商品编码', prop: 'goodsCode', width: 160 },
          { label: '商品名称', prop: 'goodsName' },
          { label: '规格', prop: 'standard' },
          { label: '箱规（件/箱）', prop: 'box' },
          { label: '计费方式', prop: 'computeTypeName' },
          { label: '计费单位', prop: 'calculationName' },
          { label: '计算数量', prop: 'num', type: 'slot' },
          { label: '单价(元)', prop: 'price', type: 'slot' },
          { label: '单项费用(元)', prop: 'money', type: 'slot' }
        ]
        return arr
      } else if (this.$route.params.computeTypeName === '重量') {
        let arr = [
          { label: '商品编码', prop: 'goodsCode', width: 160 },
          { label: '商品名称', prop: 'goodsName', width: 160 },
          { label: '规格', prop: 'standard', width: 140 },
          { label: '箱规（件/箱）', prop: 'box', width: 140 },
          { label: '计费方式', prop: 'computeTypeName', width: 140 },
          { label: '计费单位', prop: 'calculationName', width: 140 },
          { label: '计费维度', prop: 'dimensionName', width: 140 },
          { label: '计算数量', prop: 'num', width: 140, type: 'slot' },
          { label: '开始时间', prop: 'beginTime', width: 180 },
          { label: '结束时间', prop: 'endTime', width: 180 },
          { label: '首重', prop: 'beginVal', width: 140 },
          { label: '起步价', prop: 'startPrice', width: 140, type: 'slot' },
          { label: '续重单价', prop: 'price', width: 140, type: 'slot' },
          { label: '关联单号', prop: 'taskCode', fixed: 'right', width: 260, type: 'slot' }
        ]
        return arr
      } else {
        let arr = [
          { label: '编号', prop: 'costCode' },
          { label: '计费方式', prop: 'computeTypeName' },
          { label: '计费单位', prop: 'calculationName' },
          { label: '计算数量', prop: 'num', type: 'slot' },
          { label: '单价(元)', prop: 'price', type: 'slot' },
          { label: '单项费用(元)', prop: 'money', type: 'slot' }
        ]
        return arr
      }
    },
    route () {
      return this.$route.params
    }
  },
  watch: {
    // 重新请求数据
    $route (to, from) {
      if (this.$route.params.code) {
        this.code = this.$route.params.code
        this.money = this.$route.params.money
        this.getList()
      }
    }
  },
  mounted () {
    this.code = this.$route.params.code
    this.money = this.$route.params.money
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(GETRETURNDETAIL, params)
    },
    // 查看详情 -- 任务详情
    assignmentBtn (data) {
      let {finishYocType, nature} = this.route
      this.toWarehouseDetail(data.taskCode, parseInt(nature), parseInt(finishYocType))
    }
  },
  mixins: [ mixin, toWarehouse ]
}
</script>

<style scoped>
  .btm-context {
    padding: 20px 5px;
    color: #808080;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/page/costMenu/ReturnCostDetail.vue